import SauceCheeseFlavorSetterDesktop from './SauceCheeseFlavorSetterDesktop';

export default SauceCheeseFlavorSetterDesktop;
